// @ts-nocheck
export const NEW_CHAT_SETUP = "new_chat_setup";
export const JOIN_NEW_CHAT = "join_new_chat";
export const NEW_CHAT_MESSAGE = "new_chat_message";
export const MARK_NOTE_RESOLVED_EVENT = "mark_note_resolved";
export const ON_TRIGGER_NOTE_NOTIFICATION = "trigger_note_notification";
export const UPDATE_CHAT_MSG_STATUS = "update_chat_msg_status";